module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue2.fc50b16f.jpg";